import './ApplicabilityField.css';

import React from 'react';
import useB2BTranslation from '../../../b2b-common/hooks/useB2BTranslation';
import FieldComponent from '../../../b2b-common/FieldComponent';
import { generateClassName } from '../../../b2b-common/helpers';
import { Avatar, Box } from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { CalendarMonth, DateRange, Schedule } from '@mui/icons-material';
import FieldText from '../../../b2b-common/FieldText';

const parseCronExpression = (cron) => {
    if (!cron) return null;
    const parts = cron.split(' ');
    return {
        minute: parts[0],
        hour: parts[1],
        dayOfMonth: parts[2],
        month: parts[4],
        dayOfWeek: parts[5]
    };
};

const translateCronPart = (part, t, isHour = false) => {
    if (part === '*') return t('Every');
    return part.split(',').map(value => isHour ? value.padStart(2, '0') : t(value)).join(', ');
};

const ApplicabilityField = ({ objective, className = null }) => {
    const { t } = useB2BTranslation('b2b-plans');
    const applicability = parseCronExpression(objective.applicability);

    return (
        <FieldComponent
            label={t('Applicability')}
            labelAlign='left'
            component={<>
                <Box className='monthly-applicability' display={'flex'} alignItems={'center'} gap={1.5}>
                    <CalendarMonth />
                    <FieldText
                        label={''}
                        labelAlign='left'
                        text={`${
                            !applicability || applicability.month === '*' 
                                ? t('Every Month') 
                                : translateCronPart(applicability.month, t)
                        }`}
                        textAlign='left'
                        className={`theme-fieldtex-horizontal-02`}
                    />
                </Box>
                <Box className='daily-applicability' display={'flex'} alignItems={'center'} gap={1.5}>
                    <DateRange />
                    <FieldText
                        label={''}
                        labelAlign='left'
                        text={`${
                            !applicability || applicability.dayOfWeek === '*' 
                                ? t('Every Day') 
                                : translateCronPart(applicability.dayOfWeek, t)
                        }`}
                        textAlign='left'
                        className={`theme-fieldtex-horizontal-02`}
                    />
                </Box>
                <Box className='hourly-applicability' display={'flex'} alignItems={'center'} gap={1.5}>
                    <Schedule />
                    <FieldText
                        label={''}
                        labelAlign='left'
                        text={`${
                            !applicability || applicability.hour === '*' 
                                ? t('Every Hour') 
                                : translateCronPart(applicability.hour, t, true)
                        }`}
                        textAlign='left'
                        className={`theme-fieldtex-horizontal-02`}
                    />
                </Box>
            </>}
            className={`${generateClassName('applicability-field', '', className)}`}
        />
    );
}

export default ApplicabilityField;